<template>
  <div class="table1">
    <el-table :data="list" height="850" style="width: 100%" ref="table" @sort-change='sortChange'>
      <el-table-column prop="" label="基金">
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">{{ scope.row.ths_convertible_debt_short_name_cbond || '--'}}</div>
          <div style="font-size: 13px; color: #999999">{{ scope.row.code || '--'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_bond_open_cbond" label="现价" align="center" sortable='custom' >
        <template slot-scope="scope">
          <div style="font-size: 15px" :class="{'colorGreen':scope.row.ths_bond_chg_ratio_cbond && scope.row.ths_bond_chg_ratio_cbond < 0,'colorRed':scope.row.ths_bond_chg_ratio_cbond && scope.row.ths_bond_chg_ratio_cbond > 0}">
            {{ scope.row.ths_bond_open_cbond || '--'}}
          </div>
          <div style="font-size: 10px" :class="{'colorGreen':scope.row.ths_bond_chg_ratio_cbond && scope.row.ths_bond_chg_ratio_cbond < 0,'colorRed':scope.row.ths_bond_chg_ratio_cbond && scope.row.ths_bond_chg_ratio_cbond > 0}">
            {{ scope.row.ths_bond_chg_ratio_cbond || '--'}} <i v-if="scope.row.ths_bond_chg_ratio_cbond">%</i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_stock_open_cbond" label="正股价格" align="center" sortable>
        <template slot-scope="scope">
          <div style="font-size: 15px" :class="{'colorGreen':scope.row.ths_stock_chg_ratio_cbond && scope.row.ths_stock_chg_ratio_cbond < 0,'colorRed':scope.row.ths_stock_chg_ratio_cbond && scope.row.ths_stock_chg_ratio_cbond > 0}">
            {{ scope.row.ths_stock_open_cbond || '--'}}
          </div>
          <div style="font-size: 10px" :class="{'colorGreen':scope.row.ths_stock_chg_ratio_cbond && scope.row.ths_stock_chg_ratio_cbond < 0,'colorRed':scope.row.ths_stock_chg_ratio_cbond && scope.row.ths_stock_chg_ratio_cbond > 0}">
            {{ scope.row.ths_stock_chg_ratio_cbond || '--'}} <i v-if="scope.row.ths_stock_chg_ratio_cbond">%</i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_transfer_value_cbond" label="转股价格" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_transfer_value_cbond || '--'}}</template>
      </el-table-column>
      <el-table-column prop="ths_conversion_premium_rate_cbond" label="溢价率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_conversion_premium_rate_cbond || '--'}}</template>
      </el-table-column>
      <el-table-column prop="ths_stock_pb_cbond" label="正股PB" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_stock_pb_cbond || '--'}}</template>
      </el-table-column>
      <el-table-column prop="ths_conversion_price_cbond" label="转股价" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_conversion_price_cbond || '--'}}</template>
      </el-table-column>
      <el-table-column prop="ths_pure_bond_value_cbond" label="纯债价值" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_pure_bond_value_cbond || '--'}}</template>
      </el-table-column>
      <el-table-column prop="ths_bond_latest_credict_rating_bond" label="评级" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_bond_latest_credict_rating_bond || '--'}}</template>
      </el-table-column>
      <!-- <el-table-column prop="" label="期权价值" align="center" sortable></el-table-column> -->
      <el-table-column prop="ths_annual_volatility_100w_stock" label="正股波动率" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_annual_volatility_100w_stock || '--'}}</template>
      </el-table-column>
      <el-table-column prop="ths_resal_trigger_price_cbond_cbond" label="回售触发价" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_resal_trigger_price_cbond_cbond || '--'}}</template>
      </el-table-column>
      <el-table-column prop="ths_redemp_trigger_price_cbond" label="强赎触发价" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.ths_redemp_trigger_price_cbond || '--'}}</template>
      </el-table-column>
      <el-table-column prop="zhuanzhaizhanbi" label="转债占比" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.zhuanzhaizhanbi || '--'}}</template>
      </el-table-column>
      <el-table-column prop="jijinchicang" label="基金持仓" align="center" sortable>
        <template slot-scope="scope"> {{scope.row.jijinchicang || '--'}}</template>
      </el-table-column>
      <el-table-column prop="data17" label="操作" align="center">
        <template>
          <img src="../../../../public/img/index3/add.png" alt="" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {cbondList} from '../../../http/index.js'
export default {
  props:{
    
  },
  data() {
    return {
      list:[],
      page:1,
      page_number:20,
      sortObj:{},
    };
  },

  mounted() {
    this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 350 * this.page
        console.log(canshu);
        console.log(scrollTop);
        if(scrollTop > canshu){
          this.getMore()
        }
    })
  },
  methods:{
    getMore() {
      this.page++
      this.getlist()
    },
    getlist(){
      let obj = this.sortObj
      let params = Object.assign({},{page:this.page,page_number:this.page_number},obj)
      cbondList(params).then((res)=>{
        if(this.page == 1){
          this.list = res.data.list
          this.$emit('getinfo',res.data.total_data)
        }else{
          this.list = this.list.concat(res.data.list)
          
        }
       
      })
    },
    sortChange(a){
      this.page = 1
      this.list = []
      let canshu1 = a.prop
      let canshu2 
      if(a.order == 'ascending'){
        canshu2 = 'asc'
      }else if(a.order == 'descending'){
        canshu2 = 'desc'
      }else{
        canshu2 = null
      }
      if(canshu2 == null){
        this.sortObj = {}
        this.getlist()
      }else{
        let obj = {sort: `${canshu1} ${canshu2}`}
        this.sortObj = obj
        this.getlist()
      }
    }
  }
};
</script>

<style scoped>
.table1 {
  min-width: 1427px;
  position: relative;
  overflow-x: scroll;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.table1 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table1 /deep/ .cell{
  padding: 0;
}
.table1 /deep/ .el-table th.el-table__cell>.cell{
  padding:  0;
}
</style>